export default __webpack_public_path__ + "b8b2b8256d694781a98301f396e01f2e.jpg";